import React from "react";
import styled from "styled-components";

const Background = styled.path``;

const Icon = styled.path``;

const SVG = styled.svg`
  ${Background} {
    fill: ${(props) => props.theme.color.lightBlue};
  }
  ${Icon} {
    fill: ${(props) => props.theme.color.darkBlue};
  }
  &:hover {
    ${Background} {
      fill: ${(props) => props.theme.color.lightPink};
    }
    ${Icon} {
      fill: ${(props) => props.theme.color.pink};
    }
  }
`;

export const FacebookIcon: React.FC = () => (
  <SVG x="0px" y="0px" viewBox="0 0 24 24">
    <g>
      <Background
        d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M15,8h-1.3C13.1,8,13,8.2,13,8.8V10h2l-0.2,2
		H13v7h-3v-7H8v-2h2V7.7C10,5.9,10.9,5,13,5h2V8z"
      />
      <Icon d="M10,7.7V10H8v2h2v7h3v-7h1.8l0.2-2h-2V8.8C13,8.2,13.1,8,13.7,8H15V5h-2C10.9,5,10,5.9,10,7.7z" />
    </g>
  </SVG>
);
